import React, { Component, Fragment } from 'react';
import { css } from 'aphrodite/no-important';
import { I18n } from 'react-redux-i18n';
import { connect } from 'react-redux';

import Modal from '../../../common/modal/Modal';
import Confirm from '../../../common/confirm/Confirm';
import styles from '../common/statusSummary.styles';
import { HealthStatusCount } from '../common/healthStatusCount';
import { deleteSiteGatewayAction } from '../../../../reducers/actions';

class Gateways extends Component {
  handleDeleteGatewayConfirm = nodeAddress => {
    let currentSiteId = localStorage.getItem(`airfinder_selected_site`);
    this.props.deleteSiteGateway(currentSiteId, nodeAddress);
    this.props.handleDeleteModal();
  };

  render() {
    const { summary, selectedRowData } = this.props;
    return (
      <Fragment>
        <a
          href="#/?Gateways=true"
          className={css(styles.cards, styles.cardGateway)}
          onClick={() => this.props.rowDisplay('showGateway')}
          style={{
            boxShadow:
              summary.borderColor && summary.borderColor.boxShadow,
            border:
              summary.borderColor && summary.borderColor.border,
            background: this.props.activeBackground
          }}
        >
          <div className={css(styles.fieldHeader)}>
            <div className={css(styles.title)}>
              {I18n.t('gatewayTableHeader.title')}
            </div>
            <span className={css(styles.totalCount)}>
              {summary &&
                summary.totalCount}
            </span>
          </div>
          <HealthStatusCount
            counts={summary.healthStatusCount}
          />
        </a>
        <Modal
          isOpen={this.props.showModal}
          onRequestClose={this.props.handleDeleteModal}
          title={I18n.t('delete.deleteGatewayLabel')}
        >
          <Confirm
            confirm={() =>
              this.handleDeleteGatewayConfirm(selectedRowData.nodeAddress)
            }
            deny={this.props.handleDeleteClose}
            customValue={(selectedRowData && selectedRowData.nodeAddress) || ''}
            deleteText={I18n.t('delete.confirmDeleteGateway', {
              customValue:
                (selectedRowData && selectedRowData.nodeAddress) || ''
            })}
          />
        </Modal>
      </Fragment>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    deleteSiteGateway(siteId, nodeAddress) {
      dispatch(deleteSiteGatewayAction(siteId, nodeAddress));
    }
  };
};

export default connect(
  null,
  mapDispatchToProps
)(Gateways);



// WEBPACK FOOTER //
// ./src/components/data/status/gateway/index.js